import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../i18n";
import NidaLogo from "./NidaLogo";
import { SERVICE_SLUGS } from "../data/serviceDetails";

export default function Footer() {
    const { dict, t } = useI18n();
    const cats = dict.services.cats;

    return (
        <footer
            data-testid="footer"
            className="relative border-t border-white/[0.06] bg-ink-950"
        >
            <div className="container-page py-16 md:py-20">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-10">
                    <div className="lg:col-span-5">
                        <NidaLogo className="h-7" />
                        <p className="mt-5 text-sm text-white/55 max-w-xs leading-relaxed">
                            {t("footer.tagline")}
                        </p>
                        <div className="mt-6 text-xs text-white/45 space-y-1">
                            <a href="mailto:hola@nidadigital.es" className="hover:text-white transition-colors block">
                                hola@nidadigital.es
                            </a>
                            <p>Carretera CM-4005, km 14.5</p>
                            <p>45750 Huerta de Valdecarábanos, Toledo</p>
                        </div>
                    </div>

                    <FooterCol title={t("footer.services")}>
                        {cats.slice(0, 5).map((c) => (
                            <FooterRouteLink
                                key={c.key}
                                to={`/servicios/${SERVICE_SLUGS[c.key]}`}
                                testid={`footer-service-${c.key}`}
                            >
                                {c.title}
                            </FooterRouteLink>
                        ))}
                        <FooterRouteLink to="/servicios" testid="footer-service-overview">
                            {t("nav.services")}
                        </FooterRouteLink>
                    </FooterCol>

                    <FooterCol title={t("footer.company")}>
                        <FooterLink href="/#value">{t("nav.value")}</FooterLink>
                        <FooterLink href="/#cases">{t("nav.cases")}</FooterLink>
                        <FooterLink href="/#process">{t("nav.process")}</FooterLink>
                        <FooterLink href="/#trust">{t("nav.trust")}</FooterLink>
                    </FooterCol>

                    <FooterCol title={t("footer.legal")}>
                        <FooterRouteLink to="/privacidad" testid="footer-legal-privacy">
                            {t("footer.links.privacy")}
                        </FooterRouteLink>
                        <FooterRouteLink to="/terminos" testid="footer-legal-terms">
                            {t("footer.links.terms")}
                        </FooterRouteLink>
                        <FooterRouteLink to="/cookies" testid="footer-legal-cookies">
                            {t("footer.links.cookies")}
                        </FooterRouteLink>
                        <Link
                            to="/admin/login"
                            data-testid="footer-admin-link"
                            className="text-xs text-white/40 hover:text-white transition-colors block"
                        >
                            {t("nav.admin")}
                        </Link>
                    </FooterCol>
                </div>

                <div className="mt-14 pt-8 border-t border-white/[0.06] flex flex-col md:flex-row gap-4 md:items-center md:justify-between text-xs text-white/40">
                    <p>{t("footer.copyright").replace("{year}", new Date().getFullYear())}</p>
                    <p className="font-mono tracking-widest">NIDA / 360°</p>
                </div>
            </div>
        </footer>
    );
}

function FooterCol({ title, children }) {
    return (
        <div className="lg:col-span-2">
            <h4 className="text-xs uppercase tracking-[0.18em] text-white/40 mb-4">{title}</h4>
            <ul className="space-y-2.5">{children}</ul>
        </div>
    );
}

function FooterLink({ href, children }) {
    return (
        <li>
            <a href={href} className="text-sm text-white/65 hover:text-white transition-colors">
                {children}
            </a>
        </li>
    );
}

function FooterRouteLink({ to, children, testid }) {
    return (
        <li>
            <Link
                to={to}
                data-testid={testid}
                className="text-sm text-white/65 hover:text-white transition-colors"
            >
                {children}
            </Link>
        </li>
    );
}
